module.exports = __webpack_public_path__ + "img/295501d.jpg";